import React, { PureComponent } from 'react';
import DialogWrapper from '../../../common/components/DialogWrapper/DialogWrapper';
import InstrumentAutocomplete from '../../../common/components/InstrumentAutocomplete/InstrumentAutocomplete';

class AddInstrumentDialog extends PureComponent {
  render() {
    return (
      <DialogWrapper
        onClickCancel={this.props.onClickCancel}
        onClickMainAction={this.props.onClickMainAction}
        open={this.props.open}
        title="Assign instrument"
        disableMainAction={
          this.props.selectedInstrument == '' || this.props.selectedInstrument == undefined
        }
        data-qa="qa-add-instrument-dialog"
      >
        <InstrumentAutocomplete
          qaActionTag="add"
          instrumentList={this.props.assignableInstruments}
          currentInstrument={this.props.selectedInstrument}
          onChange={this.props.handleSelectedInstrument}
          disableCloseOnSelect={false}
        />
      </DialogWrapper>
    );
  }
}

export default AddInstrumentDialog;
